const makeValidNumber = (str: string | undefined | null): number | null => {
  if (str === undefined || str === null || str === '') {
    return null;
  }

  const asNumber = +str;
  if (Number.isNaN(asNumber)) {
    return null;
  }

  return asNumber;
};

export default makeValidNumber;